import { createBlockquoteTestkit } from './blockquote/blockquote.testkit';
import { createBoldTestkit } from './bold/bold.testkit';
import { createBulletListTestkit } from './bulleted-list/bullet-list.testkit';
import { createFontSizeTestkit } from './font-size/font-size.testkit';
import { createItalicTestkit } from './italic/italic.testkit';
import { createSelectionHighlightTestkit } from './selection/selection.testkit';
import { createTextAlignTestkit } from './text-align/text-align.testkit';
import { createTitleTestkit } from './title/title.testkit';

export const commonPluginTestkits = {
  bulletList: createBulletListTestkit,
  fontSize: createFontSizeTestkit,
  blockquote: createBlockquoteTestkit,
  title: createTitleTestkit,
  bold: createBoldTestkit,
  italic: createItalicTestkit,
  selectionHighlight: createSelectionHighlightTestkit,
  textAlign: createTextAlignTestkit,
} as const;
